import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

export type CreatePhasePayload = z.output<typeof createPhasePayloadSchema>;
export type CreatePhasePayloadDTO = z.input<typeof createPhasePayloadSchema>;

export const createPhasePayloadSchema = z.object({
  end: isoDatetimeToDate,
  sessionId: z.uuid(),
  start: isoDatetimeToDate,
  typeIds: z.array(z.uuid()),
});
